const stripTags = (value: string): string => {
	return value.replace(/<[^>]*>/g, '').trim();
};

const hasAnyFormatting = (value: string): boolean => {
	return /<\s*(b|strong|i|em|u|p|br|ul|ol|li)\b/i.test(value);
};

const hasFullLineFormatting = (value: string): boolean => {
	const trimmed = value.trim();
	if (!trimmed) {
		return false;
	}
	return /^<\s*(b|strong|i|em|u|p|li)\b[^>]*>.*<\/\s*\1\s*>$/i.test(trimmed);
};

const escapeHtml = (value: string): string => {
	return value
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#039;');
};

export const applyAutoOralFormatting = (input: string): string => {
	if (!input) {
		return '';
	}
	const lines = input.replace(/\r\n/g, '\n').split('\n');
	const formatted = lines.map((line, index) => {
		const currentPlain = stripTags(line);
		const nextPlain = stripTags(lines[index + 1] || '');
		const prevLine = lines[index - 1] || '';
		const prevHasFormatting = hasFullLineFormatting(prevLine);
		const currentHasFormatting = hasAnyFormatting(line);
		const shouldBold =
			currentPlain.length > 0 &&
			currentPlain.length <= 60 &&
			nextPlain.length >= 125 &&
			!prevHasFormatting &&
			!currentHasFormatting;
		if (!shouldBold) {
			return line;
		}
		return `<b>${escapeHtml(currentPlain)}</b>`;
	});
	return formatted.join('\n').replace(/\n/g, '<br />');
};
